document.addEventListener('DOMContentLoaded', () => {
  const strings = window.AukuplusI18n || {};
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('#MainNav');
  const setNav = (open) => {
    toggle?.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('is-open', open);
  };
  toggle?.addEventListener('click', () => setNav(toggle.getAttribute('aria-expanded') !== 'true'));
  nav?.addEventListener('click', (event) => { if (event.target.closest('a')) setNav(false); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setNav(false); });

  document.querySelectorAll('[data-product-grid]').forEach((grid) => {
    const catalog = grid.closest('.catalog');
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const search = catalog?.querySelector('[data-catalog-search]');
    const filters = [...(catalog?.querySelectorAll('[data-filter]') || [])];
    const sort = catalog?.querySelector('[data-sort]');
    const resultCount = catalog?.querySelector('[data-results-count]');
    let activeFilter = 'all';

    const updateResults = () => {
      const query = search?.value.trim().toLocaleLowerCase() || '';
      let visible = 0;
      cards.forEach((card) => {
        const matchesSearch = !query || card.textContent.toLocaleLowerCase().includes(query);
        const matchesFamily = activeFilter === 'all' || card.dataset.tags.includes(activeFilter);
        card.hidden = !(matchesSearch && matchesFamily);
        if (!card.hidden) visible += 1;
      });
      if (resultCount) {
        const template = visible === 1 ? strings.styleShown : strings.stylesShown;
        resultCount.textContent = (template || '{{ count }} styles shown').replace('{{ count }}', String(visible));
      }
    };

    search?.addEventListener('input', updateResults);
    filters.forEach((button) => button.addEventListener('click', () => {
      activeFilter = button.dataset.filter;
      filters.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      updateResults();
    }));
    sort?.addEventListener('change', () => {
      const orderedCards = sort.value === 'featured' ? [...cards] : [...cards].sort((a, b) => {
        const left = a.querySelector('h3')?.textContent.trim() || '';
        const right = b.querySelector('h3')?.textContent.trim() || '';
        return sort.value === 'az' ? left.localeCompare(right) : right.localeCompare(left);
      });
      orderedCards.forEach((card) => grid.appendChild(card));
    });
  });

  document.querySelectorAll('.quick-add').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    button.textContent = strings.adding || 'Adding…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }});
      if (!response.ok) throw new Error('Unable to add');
      const cart = await fetch('/cart.js').then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      button.textContent = strings.added || 'Added';
    } catch {
      button.textContent = strings.tryAgain || 'Try again';
    } finally {
      window.setTimeout(() => { button.disabled = false; button.textContent = strings.preorder || 'Pre-order'; }, 1600);
    }
  }));

  const carousel = document.querySelector('[data-hero-carousel]');
  if (carousel) {
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const current = i === active;
        slide.classList.toggle('is-active', current);
        slide.setAttribute('aria-hidden', String(!current));
      });
      dots.forEach((dot, i) => {
        const current = i === active;
        dot.classList.toggle('is-active', current);
        if (current) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    };
    const stop = () => window.clearInterval(timer);
    const restart = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), 5000);
    };
    carousel.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(active - 1); restart(); });
    carousel.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(active + 1); restart(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); restart(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', restart);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', restart);
    show(0);
    restart();
  }
});
